// ABOUTME: "Your changes will be lost" — save / don't save / cancel before leaving a form
// ABOUTME: The same confirmation as everywhere else, so it looks and closes the same

import { useTranslation } from "react-i18next"
import { CConfirmModal } from "./CConfirmModal"

interface IProps {
  isLeaveModal: boolean
  isLoading?: boolean
  /** Save is not answerable yet — the form is still being read — while staying and leaving without saving are. */
  isSaveDisabled?: boolean
  onClose: () => void
  onSave?: () => void
  onDontSave?: () => void
}

export const CLeaveModal = (props: IProps) => {
  const { onClose, onSave, onDontSave, isLeaveModal, isLoading, isSaveDisabled } = props
  const { t } = useTranslation()

  // It used to be its own CPopup: 2xl corners, an xl shadow, 30px buttons in
  // the body instead of a footer. Nothing about this question is special —
  // it is a confirmation, and the app has one of those.
  return (
    <CConfirmModal
      isShow={isLeaveModal}
      onClose={onClose}
      onSuccess={() => onSave?.()}
      isProcessing={isLoading}
      isConfirmDisabled={isSaveDisabled}
      title={t("common.changesSavedText")}
      confirmText={t("common.save")}
      showDontSave
      onDontSave={onDontSave}
    />
  )
}
